import React, { useEffect } from "react";
import ContentHeader from "../../components/ContentHeader/ContentHeader.tsx";
import TicketList from "../../components/TicketList/TicketList.tsx";
import MainLayout from "../../layout/mainlayout.tsx";
import { useGetAllTicketsQuery } from "../../services/ticket.api.ts";
import "./Ticket.css";

const Tickets: React.FC = () => {
  const { data: tickets, isLoading: isTicketLoading, isError: isTicketError } = useGetAllTicketsQuery();

  // Handle loading state
  if (isTicketLoading) {
    return (
      <MainLayout>
        <div className="tickets--container">
          <ContentHeader>Tickets</ContentHeader>
          <div>Loading tickets...</div>
        </div>
      </MainLayout>
    );
  }

  // Handle error state
  if (isTicketError) {
    return (
      <MainLayout>
        <div className="tickets--container">
          <ContentHeader>Tickets</ContentHeader>
          <div>Error loading tickets</div>
        </div>
      </MainLayout>
    );
  }

  // Render tickets if no errors and not loading
  return (
    <MainLayout>
      <div className="tickets--container">
        <ContentHeader>Tickets</ContentHeader>
        <TicketList tickets={tickets || []}>
          20
        </TicketList>
      </div>
    </MainLayout>
  );
};

export default Tickets;
